import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useUserStore } from './stateManagement/userZustand';
import { useURLStore } from './stateManagement/URLZustand';

const Logout = () => {
    const { handleLogout } = useUserStore();
    const { getURLTo } = useURLStore();
    const history = useHistory();
    useEffect(() => {
        const logoutAndRedirect = async () => {
            await handleLogout();
            history.push(getURLTo().home());
            window.location.reload();
        };
        logoutAndRedirect();
    }, []);
    
    return null;
};

export default Logout;
